import React from 'react';

export const VideoViewersIcon = () => (
  <svg width='15' height='13' viewBox='0 0 15 13' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.61306 0.931152C11.2077 0.931152 14.1984 3.51782 14.8257 6.93115C14.1991 10.3445 11.2077 12.9312 7.61306 12.9312C4.01839 12.9312 1.02772 10.3445 0.400391 6.93115C1.02706 3.51782 4.01839 0.931152 7.61306 0.931152ZM7.61304 9.93115C5.95618 9.93115 4.61304 8.58801 4.61304 6.93115C4.61304 5.2743 5.95618 3.93115 7.61304 3.93115C8.17251 3.93115 8.69622 4.0843 9.14452 4.35097C8.97758 4.29483 8.79882 4.2644 8.61296 4.2644C7.69248 4.2644 6.94629 5.0106 6.94629 5.93107C6.94629 6.85154 7.69248 7.59774 8.61296 7.59774C9.53343 7.59774 10.2796 6.85154 10.2796 5.93107C10.2796 5.74511 10.2492 5.56627 10.193 5.39925C10.4598 5.84764 10.613 6.3715 10.613 6.93115C10.613 8.58801 9.26989 9.93115 7.61304 9.93115Z'
      fill='var(--accent-green)'
    />
  </svg>
);
